module.exports = __webpack_public_path__ + "img/reportaroo-white.6b663ca4.svg";